export enum OfferType {
  BranchOffer = 'Branch Offer',
  NoCreditOffer = 'No Credit Offer',
  OnlineOffer = 'Online Offer',
}
